// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1MBrp","form":"styles_form__2B74k"};